import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import NoteForm from './forms/NoteForm';
import { NoteCauses, NoteTypes, PurchaseDocumentPaymentDataForm } from '../../../app/models/PurchaseDocument';
import { Society } from '../../../app/models/Society';
import { PurchaseDocument } from '../../../app/models/PurchaseDocument';
import { Tax } from '../../../app/models/Tax';
import { Provider } from '../../../app/models/Provider';


interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    note: any;
    setNote: (note: any) => void;

    noteTypes: NoteTypes[];
    setNoteTypes: (note: any) => void;
    causes: NoteCauses[];
    setCauses: (causes: any) => void;

    taxesData?: Tax[];

    availableStatuses: PurchaseDocumentPaymentDataForm[];  
    errorFields?: any;
    updated: boolean;
    disabled: boolean;
    purchaseDocuments: PurchaseDocument[];
    societies: Society[];
    providers: Provider[];
    loadingClient?: boolean;


}

const NoteFormContainer = ({
    fetching,
    action,
    cancel,
    note,
    noteTypes,
    causes,
    setNote,
    setNoteTypes,
    setCauses,
    taxesData,
    availableStatuses,
    updated = false,
    disabled= false,
    errorFields = null,
    purchaseDocuments,
    societies,
    providers,
    loadingClient
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <NoteForm
                        note={note}
                        setNote={setNote}
                        societies={societies}
                        providers={providers}
                        noteTypes={noteTypes}
                        setNoteTypes={setNoteTypes}
                        causes={causes}
                        setCauses={setCauses}
                        purchaseDocuments = {purchaseDocuments}
                        taxesData={taxesData}
                        availableStatuses={availableStatuses}  
                        errorFields={errorFields}
                        disabled={updated}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default NoteFormContainer;
